export const DESCRIPTOR_REVIEW_TYPES = [
  { id: 'beer', label: 'Beer' },
  { id: 'brewery', label: 'Brewery' },
  { id: 'event', label: 'Event' },
];

export const DESCRIPTOR_CATEGORIES = {
  beer: [
    { id: 'appearance', label: 'Appearance' },
    { id: 'aroma', label: 'Aroma' },
    { id: 'flavor', label: 'Flavor' },
    { id: 'mouthfeel', label: 'Mouthfeel' },
  ],
  brewery: [
    { id: 'service', label: 'Service' },
    { id: 'atmosphere', label: 'Atmosphere' },
    { id: 'food', label: 'Food' },
    { id: 'amenities', label: 'Amenities' },
  ],
  event: [
    { id: 'beer', label: 'Beer Selection?' },
    { id: 'experience', label: 'Pouring Experience?' },
    { id: 'layout', label: 'Event Layout & Navigation' },
    { id: 'food', label: 'Food & Water Access?' },
    { id: 'vibe', label: 'Vibe & Atmosphere' },
  ],
};

export const DESCRIPTOR_REQUEST_STATUSES = [
  { id: 'pending', label: 'Pending' },
  { id: 'approved', label: 'Approved' },
  { id: 'declined', label: 'Declined' },
];

export function descriptorReviewTypeLabel(domain) {
  const match = DESCRIPTOR_REVIEW_TYPES.find((reviewType) => reviewType.id === domain);
  return match ? match.label : domain;
}

export function descriptorCategoryLabel(domain, category) {
  const categories = DESCRIPTOR_CATEGORIES[domain] ?? [];
  const match = categories.find((item) => item.id === category);
  return match ? match.label : category;
}

export function descriptorCategoriesFor(domain) {
  return DESCRIPTOR_CATEGORIES[domain] ?? [];
}

export function formatDescriptorRequestDate(iso) {
  if (iso === null) {
    return '';
  }
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(parsed);
}
